import React from "react";
import moment from "moment";
import Dialog from "../Dialog";
import MUILoadingButton from "@mui/lab/LoadingButton";
import MUIButton from "@mui/material/Button";
import MUIDialogActions from "@mui/material/DialogActions";
import MUITypography from "@mui/material/Typography";
import MUIContainer from "@mui/material/Container";
import MUIFormControl from "@mui/material/FormControl";
import MUIFormLabel from "@mui/material/FormLabel";
import MUIFormControlLabel from "@mui/material/FormControlLabel";
import MUIRadioGroup from "@mui/material/RadioGroup";
import MUIRadio from "@mui/material/Radio";
import MUIGrid from "@mui/material/Grid";

export default class DialogConfirmPatientMerge extends Dialog {
  /**
   * Render header title of dialog
   */
  renderHeader() {
    return (
      <MUITypography variant="h6" color="textPrimary">
        Merge Patients
      </MUITypography>
    );
  }

  /**
   * Render main content text of dialog
   */
  renderContent() {
    return (
      <>
        <MUITypography variant="body1" color="textPrimary" sx={{ mb: 2 }}>
          Select the master record to merge all selected patients. Changes
          cannot be undone.
        </MUITypography>
        <MUIContainer disableGutters sx={{ mt: 3 }}>
          <MUIFormControl component="fieldset" required sx={{ width: "100%" }}>
            <MUIFormLabel>Select one</MUIFormLabel>
            <MUIRadioGroup
              value={
                this.props.selectedMasterRecord !== undefined
                  ? this.props.selectedMasterRecord
                  : null
              }
              onChange={(e) => this.props.onChange(e)}
            >
              {this.props.selectedRowsData.map((row) => (
                <MUIFormControlLabel
                  key={row.id}
                  checked={
                    this.props.selectedMasterRecord === row.id.toString()
                  }
                  value={row.id.toString()}
                  control={<MUIRadio size="small" />}
                  lg={"auto"}
                  sx={{
                    "& .MuiTypography-root": {
                      width: "100%",
                    },
                  }}
                  label={
                    <MUIGrid container spacing={2} alignItems="center">
                      <MUIGrid item xs={4}>
                        <MUITypography
                          variant="body2"
                          noWrap
                          title={row.patient}
                        >
                          {row.patient}
                        </MUITypography>
                      </MUIGrid>

                      <MUIGrid item xs={2}>
                        <MUITypography variant="body2" noWrap>
                          {`ID: #${row.id}`}
                        </MUITypography>
                      </MUIGrid>

                      {row.dateOfBirth && (
                        <MUIGrid item xs={3}>
                          <MUITypography variant="body2" noWrap>
                            {`DOB: ${moment(row.dateOfBirth).format("M/D/YYYY")}`}
                          </MUITypography>
                        </MUIGrid>
                      )}

                      {row.phone && (
                        <MUIGrid item xs={3}>
                          <MUITypography variant="body2" noWrap>
                            {`Phone #: ${row.phone
                              .replace(/\D/g, "")
                              .replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3")
                              .padStart(14, row.phone)}`}
                          </MUITypography>
                        </MUIGrid>
                      )}
                    </MUIGrid>
                  }
                />
              ))}
            </MUIRadioGroup>
          </MUIFormControl>
        </MUIContainer>
      </>
    );
  }

  /**
   * Render cancel and confirm button actions of dialog.
   */
  renderActions() {
    return (
      <MUIDialogActions spacing={2}>
        <MUIButton variant="text" onClick={this.props.onClose}>
          Cancel
        </MUIButton>
        <MUILoadingButton
          variant="contained"
          disabled={!this.props.selectedMasterRecord}
          loading={this.props.loading}
          onClick={this.props.onConfirm}
        >
          Merge Patients
        </MUILoadingButton>
      </MUIDialogActions>
    );
  }

  /**
   * @returns {string} The max width of the dialog.
   */
  getMaxWidth() {
    return "md";
  }
}
